const menu = document.querySelector(".menu");
const menuBtn = document.querySelector(".menu-btn");
const header = document.querySelector(".header");
const closeBtn = document.querySelector(".close-btn");
const mainNav = document.getElementById("nav-main");
const subMenu = document.querySelectorAll(".sub-menu");
const toggleBtn = document.querySelectorAll(".toggle-btn");
const overlay = document.querySelector(".overlay");


// Sticky header
document.addEventListener("scroll", () => {
	header.classList.add("fixed");
	if (window.scrollY < 100) {
		header.classList.remove("fixed");
	}
});


// Nav
const toggleMenu = () => {
	menu.classList.toggle("open");
	mainNav.classList.toggle("open");
	if (!menu.classList.contains("open")) {
		overlay.classList.remove("open");
	}
}

const closeMenu = () => {
	mainNav.classList.remove("open");
	menu.classList.remove("open");
	overlay.classList.remove("open");
	subMenu.forEach(menu => {
		if (menu.classList.contains("open")) {
			menu.classList.remove("open");
		}
	})
	toggleBtn.forEach(btn => {
		if (btn.classList.contains("open")) {
			btn.classList.remove("open");
		}
	})
}

toggleBtn.forEach(btn => {
	btn.addEventListener("click", function(e) {
		e.preventDefault();
		this.classList.toggle("open");
		this.previousElementSibling.classList.toggle("open");
	})
})

document.addEventListener("keyup", (e) => {if (e.key === "Escape") closeMenu()});

document.addEventListener("click", () => {
	if (menu.classList.contains("open")) {
		overlay.classList.add("open");
	}
});

menuBtn.addEventListener("click", toggleMenu);
overlay.addEventListener("click", closeMenu);
closeBtn.addEventListener("click", closeMenu);

// Always fire closeMenu() at 1024px breakpoint
const mq = window.matchMedia("screen and (min-width: 1024px)");

mq.addEventListener("change", event => {if (event.matches) closeMenu()});
